import { render, staticRenderFns } from "./NormalSearchNav170.vue?vue&type=template&id=890cf4b0&scoped=true&"
import script from "./NormalSearchNav170.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav170.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890cf4b0",
  null
  
)

export default component.exports